import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "position", "isVisible"];
import { forwardRef } from 'react';
import ReactDOM from 'react-dom';
import TooltipContent from "./TooltipContent";
import { jsx as _jsx } from "react/jsx-runtime";
var TooltipPopup = function TooltipPopup(_ref, forwardedRef) {
  var label = _ref.label,
    position = _ref.position,
    isVisible = _ref.isVisible,
    rest = _objectWithoutProperties(_ref, _excluded);
  return isVisible ? /*#__PURE__*/ReactDOM.createPortal(
  /*#__PURE__*/
  // @ts-ignore
  _jsx(TooltipContent, _objectSpread({
    label: label,
    position: position,
    isVisible: isVisible,
    ref: forwardedRef
  }, rest)), document.body) : null;
};
export default /*#__PURE__*/forwardRef(TooltipPopup);